/// <reference path="../typings/index.d.ts" />

import $ = require("jquery");
import "bootstrap";

import { Template } from "./Framework/Template";
import { Components } from "./Framework/Components";
import { Extensions } from "./Framework/Extensions";
import { FooTable } from "./Vendors/FooTable";
import { DataTable } from "./Vendors/DataTable";
import { Select2Module } from "./Vendors/Select2Module";
import { ResponsiveTab } from "./Vendors/ResponsiveTab";
import { Sortable } from "./Vendors/Sortable";
import { Collections } from "./Vendors/Collections";
import { Pjax } from "./Vendors/Pjax";

import * as Common_MaskedTextbox from "./Common/MaskedTextbox";
import * as Framework_SignalR from "./Framework/SignalR";
import { Slider } from "./Vendors/Slider";
import { Scrollbar } from "./Vendors/Scrollbar";

//import "../node_modules/simple-line-icons/scss/simple-line-icons.scss";


export module App {

	export async function initAppAsync(container?: JQuery, replace?: Boolean): Promise<void> {

		window.MovedComponentList = new Collections.Dictionary<string, object>();

		if (!container) {
			container = $("body");

			$(window).on('beforeunload', function () {
				console.log("beforeUnload event!");
			});


			Extensions.init();
			Template.init();
		}

		onWindowResize();

		await Common_MaskedTextbox.Common.initAllAsync(container);
		await FooTable.initAllAsync(container);
		await DataTable.initAllAsync(container);
		//await ResponsiveTab.initAllAsync(container);
		await Select2Module.initAllAsync(container);
		await Slider.initAllAsync(container);
		await Scrollbar.initAllAsync(container);

		await Components.initAsync(container, replace);

		//if (container == $("body"))
		await Pjax.initAllAsync(container);

		var h = ($(window).height() || 300) - 80;
		$(".body-content").css("min-height", h + "px");
		$(window).resize(() => {
			onWindowResize();
		});

		await Sortable.initAllAsync(container);

		await Framework_SignalR.Framework.SignalR.InitAllAsync(container);

		(<any>(jQuery.fn.modal)).Constructor.prototype.enforceFocus = jQuery.noop();


		$("body").addClass("loaded");
	}

	function onWindowResize() {

		var h = ($(window).height() || 300) - 80;
		$(".body-content").css("min-height", h + "px");

		var width = $(window).width() || 300;
		if ((width < 992) && (!$("body").hasClass("sidebar-mobile-show")))
			$("body").addClass("sidebar-hidden");
		else
			$("body").removeClass("sidebar-hidden");

	}

}

$(document).ready(async () => { await App.initAppAsync(); });
